import { Box, Flex, HStack } from "@chakra-ui/react";
import { FC } from "react";

import { DashboardFeaturedCard } from "components/DashboardFeatCard";
import { Listing } from "models/cards";
import { PagedResult } from "models/common";

type TopActiveListingsProps = {
    cards?: PagedResult<Listing>;
};

const YourTopActiveListings: FC<TopActiveListingsProps> = ({ cards }) => {
    return (
        <Box
            borderRadius="lg"
            style={{
                background: "rgb(0 0 0 / 0.5)",
                width: "100%",
            }}
        >
            <Flex px={4} pt={2} flexDir={{ base: "column", md: "row" }}>
                <Box fontSize={22} fontWeight="semibold" color="white">
                    Your Top Active Listings
                </Box>
            </Flex>

            <HStack
                color="darkGray"
                flexDir="row"
                px={8}
                py={4}
                spacing={8}
                overflowX="scroll"
            >
                {cards?.data && cards.data.length > 0 ? (
                    cards?.data.map((card) => (
                        <DashboardFeaturedCard card={card} key={card.sku} />
                    ))
                ) : (
                    <Box fontSize={16}>No packages</Box>
                )}
            </HStack>
        </Box>
    );
};

export default YourTopActiveListings;
